/**
 * @generated SignedSource<<fb3b0a72a66ffe59ce20b0b67689875f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type quickSearchDialogResultsMenuQuery$variables = Record<PropertyKey, never>;
export type quickSearchDialogResultsMenuQuery$data = {
  readonly treeMenu: string;
};
export type quickSearchDialogResultsMenuQuery = {
  response: quickSearchDialogResultsMenuQuery$data;
  variables: quickSearchDialogResultsMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "treeMenu",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "quickSearchDialogResultsMenuQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "quickSearchDialogResultsMenuQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "75cfb442650eeb78c207dc9588807505",
    "id": null,
    "metadata": {},
    "name": "quickSearchDialogResultsMenuQuery",
    "operationKind": "query",
    "text": "query quickSearchDialogResultsMenuQuery {\n  treeMenu\n}\n"
  }
};
})();

(node as any).hash = "589172364b3c3dba4f2d1200ebecc701";

export default node;
